import React from 'react'
import PropTypes from 'prop-types'

import { Image } from 'semantic-ui-react'

import Permissions from 'Components/Permissions'
import PictureLoader from 'Components/PictureLoader'

import { PICTURE_TYPES } from 'Global/constants'
import { getFullPicturefilePath } from 'Global/Helpers/rugHelpers'
import { getRibbon } from './helpers'

const PictureCardPicture = props => {
  const { isPending, picture, togglePreview } = props

  const src = getFullPicturefilePath(picture, PICTURE_TYPES.C3_BIG)

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a onClick={togglePreview}>
      <PictureLoader pending={isPending} />

      <Permissions
        permissions={['picture.picture.nonPrimary', 'picture.picture.qcPicture']}
        render={() => <Image disabled={isPending} label={getRibbon(picture)} src={src} fluid />}
        renderElse={() => <Image disabled={isPending} src={src} fluid />}
      />
    </a>
  )
}

PictureCardPicture.propTypes = {
  isPending: PropTypes.bool.isRequired,
  picture: PropTypes.object.isRequired,
  togglePreview: PropTypes.func.isRequired,
}

export default PictureCardPicture
